import type { TipoObraTagProps } from "./types-tipo-obra-tag";
import { TipoObraTagView } from "./view-tipo-obra-tag";

/**
 * Tag de um tipo de obra (Figma tag-coletor 713:28607): `Tag` do Prime com o código e a cor do tipo (100, 101, 102, 103,
 * 105 e 301; os demais no neutro). Usada pelas Obras (cards e tabela) e pelo Gantt.
 */
export function TipoObraTag(props: TipoObraTagProps) {
  return <TipoObraTagView {...props} />;
}

export { TIPOS_OBRA_COM_COR } from "./tipo-obra-tag.constants";
export type * from "./types-tipo-obra-tag";
